export default __webpack_public_path__ + "static/media/Cd.cde616ca.png";